module.exports = __webpack_public_path__ + "media/images/e-bilet/Globus-org-1adbcad7f9633e17ab70b9f375944a81.svg";